<template>
  <div>
    <div id="loader">
      <FacadePlanning :facade_id="facade_id">
      </FacadePlanning>
    </div>
    
    <div class="click_slider">
      <div class="left-next" v-on:click="pushToLeft()">
        <i class="el-icon-back"></i>
      </div>
      <div class="right-next" v-on:click="pushToRight()">
        <i class="el-icon-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import FacadePlanning from './FacadePlanning.vue';

export default {
  name: "facadePlanningCArousel",
  props: ['house_id'],
  components: { FacadePlanning },

  data() {
    return {
      facade_id: null
    };
  },

  computed: {
    ...mapGetters({
      facade_plannings: "facadePlans/facade_plannings",
    })
  },

  async created() {
    await this.fetchData();

    if (this.facade_plannings) {
      this.facade_id = this.facade_plannings[0].id;
    }
  },

  methods: {
    ...mapActions({
      getFacadePlanning: "facadePlans/getFacadePlanning"
    }),

    pushToRight() {
      let all = this.facade_plannings;
      for (let init in all) {
        if (all[init].id == this.facade_id) {
          this.right = ++init;
        }
      }

      if (this.right < all.length) {
        this.facade_id = all[this.right].id;
      }
    },

    pushToLeft() {
      this.all = this.facade_plannings;
      this.index = this.all.length;
      this.index = --this.index;

      for (this.init = 0; this.init <= this.index; this.init++) {
        if (this.all[this.init].id == this.facade_id) {
          this.left = this.init;
          this.left = --this.left;
        }
      }

      if (this.left >= 0) {
        this.facade_id = this.all[this.left].id;
      }
    },

    async fetchData() {
      if (this.house_id) {
        await this.getFacadePlanning(this.house_id)
          .then((res) => {
          })
          .catch((err) => {
          });
      }
    }
  }
};
</script>

<style lang="scss">
.load {
  position: relative;
  margin: 50px auto;
  width: 100px;
  height: 80px;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.loading_div {
  width: 100%;
  height: 100%;
  // height: calc(100vh - 60px);
  height: 100vh;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9999;
  overflow: hidden;
}

.lil-circle {
  position: absolute;
  border-radius: 50%;
  box-shadow: inset 0 0 10px 2px gray, 0 0 50px white;
  width: 100px;
  height: 100px;
  opacity: .65;
}

.blur-circle {
  position: absolute;
  top: -19px;
  left: -19px;
}

.text {
  color: lightgray;
  font-size: 18px;
  font-family: 'Open Sans', sans-serif;
  text-align: center;
}

.loaded .loading_div {
  opacity: 0;
  transition: all 0.3s ease-out;
}

#loader {
  overflow: hidden;
  // height: calc(100vh - 60px);
  height: 100vh;
}

#loader .vw_100 {
  height: 100vh;
  // height: calc(100vh - 60px);
}

.click_slider {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 1;
  padding: 0 85px;
  pointer-events: none;
  // background: #00000080;
}

.click_slider div {
  border-radius: 50%;
  background: #fff;
  background: rgba(255, 255, 255, 0.7);
  -webkit-box-shadow: 0 3px 7px rgba(0, 0, 0, 0.15);
  box-shadow: 0 3px 7px rgba(0, 0, 0, 0.15);
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  pointer-events: all;
  z-index: 999;
}

.click_slider div:hover {
  cursor: pointer;
}

.click_slider div i {
  font-size: 26px;
  color: #ca9760 !important;
}
</style>